import { connect } from "react-redux";
import * as financingActions from "../../../services/financing/actions";
import * as mplFinancingActions from "../../../services/financing/mpl.financing/actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state) {
  return {
    financingsIssued: state.mplFinancing.financingsIssued,
    accountInfo: state.financing.accountInfo,
    payout: state.payout,
    isMpl: true,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFinancingBookingAccountInfo: (accountId) => {
      dispatch(financingActions.get_financing_booking_account_info(accountId));
    },

    changeFinancingIssuedListPage: (page) => {
      dispatch(mplFinancingActions.change_financing_list_page(page, "Issued"));
    },

    changeFinancingIssuedListFilter: (keyName, event) => {
      dispatch(
        mplFinancingActions.change_financing_list_filter(
          keyName,
          event.target.value,
          "Issued",
        ),
      );
    },

    getFinancingPayoutInfo: (financingId, offerId, assetType) => {
      dispatch(
        mplFinancingActions.get_financing_payout_info(
          financingId,
          offerId,
          assetType,
        ),
      );
    },

    registerPayout: (financingId, bankingDate) => {
      bankingDate = moment(bankingDate).format("YYYY-MM-DD");
      dispatch(
        mplFinancingActions.register_financing_payout(financingId, bankingDate),
      );
    },

    pushErrorNotification: (message) => {
      dispatch({
        type: "ERROR_NOTIFIACTION",
        message,
      });
    },
  };
}

export const mplPayoutConnector = connect(mapStateToProps, mapDispatchToProps);
